<template>
  <div>
    <b-container fluid class="px-0">
      <div class="bg-light mb-3 sticky-footer p-2">
        <b-row class="align-items-center">
          <b-col cols="12" md="4" class="mb-2 mb-md-0">
            <b-input-group class="w-100 px-0" prepend="Category">
              <template v-slot:append>
                <b-btn class="text-decoration-none" variant="danger" @click="addModal = true">
                  Category
                  <font-awesome-icon icon="plus" />
                </b-btn>
              </template>
              <b-select
                :options="getCats"
                v-model="category"
                @change="changeCategory"
                text-field="CategoryDESC"
                value-field="CategoryID"
              />
            </b-input-group>
          </b-col>
          <b-col cols="12" md="8">
            <div class="d-flex flex-column flex-md-row justify-content-end" style="gap: 10px;">

                <b-btn variant="danger" style="margin-right:auto" :disabled="!currentMenuType" @click="$emit('openDuplicateMenu')">
                  <img src="/img/duplicate-menu-white.png" alt="Duplicate Menu" style="width: 16px; height: 16px;" class="mr-1 align-middle">
                  DUPLICATE MENU
                </b-btn>

                <b-btn v-if="chefPickFilter" :disabled="DisabledchefPickFilter" @click="chefPickFilter = !chefPickFilter" variant="warning" >Chef Pick</b-btn>
                <b-btn v-else :disabled="DisabledchefPickFilter" @click="chefPickFilter = !chefPickFilter" :style="{backgroundColor: 'rgb(255, 224, 178, 0)', color: 'black', 'opacity': DisabledchefPickFilter ? 0.25 : 1 }">Chef Pick</b-btn>

                <b-btn v-if="newFilter" :disabled="DisablednewFilter" @click="newFilter = !newFilter" variant="warning" >What's New</b-btn>
                <b-btn v-else :disabled="DisablednewFilter" @click="newFilter = !newFilter" :style="{backgroundColor: 'rgb(255, 224, 178, 0)', color: 'black', 'opacity': DisablednewFilter ? 0.25 : 1 }">What's New</b-btn>

                <b-btn v-if="veggieFilter" :disabled="DisabledveggieFilter" @click="veggieFilter = !veggieFilter" variant="warning">Veggie/Vegan</b-btn>
                <b-btn v-else :disabled="DisabledveggieFilter"  @click="veggieFilter = !veggieFilter" :style="{backgroundColor: 'rgb(255, 224, 178, 0)', color: 'black', 'opacity': DisabledveggieFilter ? 0.25 : 1 }">Veggie/Vegan</b-btn>

                <b-btn v-if="glutenFilter" :disabled="DisabledglutenFilter" @click="glutenFilter = !glutenFilter" variant="warning">Gluten Free</b-btn>
                <b-btn v-else :disabled="DisabledglutenFilter" @click="glutenFilter = !glutenFilter" :style="{backgroundColor: 'rgb(255, 224, 178, 0)', color: 'black', 'opacity': DisabledglutenFilter ? 0.25 : 1 }">Gluten Free</b-btn>

                <b-btn v-if="noPhotoFilter" :disabled="DisablednoPhotoFilter" @click="noPhotoFilter = !noPhotoFilter" variant="warning">No Photo</b-btn>
                <b-btn v-else :disabled="DisablednoPhotoFilter" @click="noPhotoFilter = !noPhotoFilter" :style="{backgroundColor: 'rgb(255, 224, 178, 0)', color: 'black', 'opacity': DisablednoPhotoFilter ? 0.25 : 1 }">No Photo</b-btn>

            </div>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col
          cols="12"
          v-for="(category, key) in items"
          :id="'category-' + category.CategoryID"
          :key="`category_${key}_${category.CategoryID}`"
        >
          <div class="mb-3 category-box" :class="hasActiveFood(category) ? '' : 'no-active-food'">
            <div class="category-title p-3" :class="category.categoryClass">
              <div class="position-absolute px-2 menu-type-badge" style="top: -3px; left: 15px">
                {{ currentMenuType.MenuType }}
              </div>
              <b-container class="px-0" fluid @click="showFood(category)" >
                <b-row class="align-items-center">
                  <b-col cols="12" md="4" class="d-flex justify-content-center justify-content-md-start pb-3 pb-md-0">
                    <div style="font-style: italic">
                      <span class="font-weight-bold">Display: </span>
                      {{ findKds(category.KDS) }}
                    </div>
                    <div style="font-style: italic" class="ml-5">
                      <span class="font-weight-bold">Printer: </span>
                      {{ findDisplay(category.PrintStation) }}
                    </div>
                  </b-col>
                  <b-col
                    cols="12"
                    md="4"
                    class="text-center pb-3 pb-md-0 h5 font-weight-bold text-white mb-0 cursor-pointer"
                    
                  >
                    <div >
                      <span @click="showCategory(category)">{{ category.CategoryDESC }}</span>                                    
                      <font-awesome-icon @click="showCategory(category)" icon="pencil-alt" class="ml-1 cursor-pointer" style="font-size: 1rem; color: white"/>
                      <img @click.stop="openDuplicateModal(category)" src="/img/duplicate-menu-white.png" alt="Duplicate Category" class="ml-4 cursor-pointer align-middle" style="width: 15px; height: 15px;">
                    </div>
                    <div v-if="category.CategoryComment" class="font-weight-normal small" style="font-style: italic">
                      {{ category.CategoryComment }}
                    </div>
                  </b-col>
                  <b-col cols="12" md="4" class="text-center text-md-right">
                    <create-food
                      :category="category"
                      :AllowSecondLang="AllowSecondLang"
                      :edible-type="edibleType"
                      @refresh="getCategoryFoods"
                    />
                    <c-switch
                      v-if="category.open"
                      class="ml-3"
                      color="warning"
                      label
                      :disabled="category.foods.length ? false : true"
                      v-model="category.IsAvailable"
                      @click="changeAvailable(category)"
                      dataOn="on"
                      dataOff="off"
                    />
                    <b-btn @click="showFood(category)" variant="transparent">
                      <font-awesome-icon class="align-middle text-dark" :icon="category.open ? 'chevron-up' : 'chevron-down'" />
                    </b-btn>
                  </b-col>
                </b-row>
              </b-container>
            </div>
            <b-collapse v-model="category.open">
              <div class="category-body bg-white" :class="category.foods.length ? 'px-3' : ''">
                <b-container fluid class="px-0">
                  <b-row v-if="category.foods.length">
                    <b-col class="p-1" v-for="food in category.foods" :key="food.ID" cols="12" md="6">
                      <div class="p-2 h-100" :class="foodBoxColor(food)" style="border: 1px solid #e4e7ea" v-if="compliesWithFilters(food)">
                        <food-item
                          :value="food"
                          :foods="category.foods"
                          :edible-type="edibleType"
                          :category="category"
                          @refresh="getCategoryFoods"
                          :AllowSecondLang="AllowSecondLang"
                          :kds="findKds(category.KDS)"
                          :display="findDisplay(category.PrintStation)"
                          :loyalty-permission="loyaltyPermission"
                          :loyalty-allowance="loyaltyAllowance"
                          :loyalty-rewards-full="loyaltyRewardsFull"
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col cols="12">
                      <no-item title="No food available" />
                    </b-col>
                  </b-row>
                </b-container>
                <!--                            {{category}}-->
              </div>
            </b-collapse>
          </div>
        </b-col>
      
      </b-row>

      <create-category
        v-model="addModal"
        :current-menu-type="currentMenuType"
        :edible-type="edibleType"
        @refresh="refreshCategories"
      />
      <edit-category
        v-model="editModal"
        :category="{...currentCategory}"
        :edible-type="edibleType"
        :categories="items"
        @refresh="refreshCategories"
        :current-menu-type="currentMenuType"
      />
      <duplicate-category
        v-model="duplicateModal"
        :category="duplicatingCategory"
        :edible-type="edibleType"
        :current-menu-type="currentMenuType"
        @refresh="onCategoryDuplicated"
      />
    </b-container>
  </div>
</template>

<script>
import CreateCategory from './createCategory'
import EditCategory from './editCategory'
import DuplicateCategory from './DuplicateCategory'
import FoodItem from './components/foodItem'
import CreateFood from './components/createFood'
import {Switch as cSwitch} from '@/components/shared'
import NoItem from '../../../shared/noItem'
export default {
  name: 'categories',
  components: {NoItem, CreateFood, FoodItem, EditCategory, CreateCategory, DuplicateCategory, cSwitch},
  props: {
    firstCat: {
      required: false
    },
    items: {
      required: true,
      default: [],
      type: Array
    },
    kdsList: {
      required: true,
      default: [],
      type: Array
    },
    printStationList: {
      required: true,
      default: [],
      type: Array
    },
    currentMenuType: {
      required: true
    },
    edibleType: {required: true, type: String},
    AllowSecondLang: {required: true, type: Boolean, default: false}
  },
  watch: {
    firstCat: {
      handler: function(newVal) {
        this.category = newVal
        this.loadAllfoods()
        
      }
    },
    '$store.state.selectedRestaurantId': {
      handler: function(newVal) {
        if (newVal) {
          this.getLoyaltySettings()
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      addModal: false,
      editModal: false,
      currentCategory: {},
      duplicateModal: false,
      duplicatingCategory: {},
      addFoodModal: false,
      category: this.firstCat,
      loadingFood: false,
      chefPickFilter: false,
      newFilter: false,
      veggieFilter: false,
      glutenFilter: false,
      noPhotoFilter: false,
      DisabledchefPickFilter: false,
      DisablednewFilter: false,
      DisabledveggieFilter: false,
      DisabledglutenFilter: false,
      DisablednoPhotoFilter: false,
      loyaltyPermission: false,
      loyaltyAllowance: false,
      loyaltyRewardsFull: [],
    }
  },
  computed: {
    getCats() {
      return [...this.items]
    },
    allFiltersOff() {
      return !this.noPhotoFilter && !this.veggieFilter && !this.glutenFilter && !this.newFilter && !this.chefPickFilter
    },
    categoryStatus() {}
  },
  methods: {
    loadAllfoods(){
      this.items.forEach(category => {
        this.getCategoryFoods(category)
      })
    },
    hasActiveFood(category) {
      if(this.allFiltersOff) {
        return true
      } else {
        return category.foods.some(food => this.compliesWithFilters(food))
      }
    },
    showCategory(category) {
      this.currentCategory = category
      this.$nextTick(() => {
        this.editModal = true
      })
    },
    scrollToCategory(categoryId) {
      this.$nextTick(() => {
        const headerOffset = 110
        const el = document.getElementById(`${categoryId}`)
        if (el) {
          const bodyPosition = el.getBoundingClientRect().top
          const offsetPosition = bodyPosition + window.pageYOffset - headerOffset
          window.scrollTo({top: offsetPosition, behavior: 'smooth'})
        } else {
          this.$showError('Tag Not Found!!!!')
        }
      })
    },
    changeCategory(cat) {
      if (cat) {
        this.scrollToCategory(`category-${cat}`)
        const findCategory = this.items.find(item => item.CategoryID === cat)
        if (findCategory) {
          this.showFood(findCategory)
        }
      }
    },
    refreshCategories(menuType) {
      this.$emit('getCategories', menuType)
    },
    getLoyaltySettings() {
      const model = {RestaurantID: Number(this.$store.state.selectedRestaurantId)}
      return this.$api.loyaltyAdmin.GetSettings(model).then(res => {
        if (res.success) {
          this.loyaltyPermission = !!res.results.LoyaltyPermission
          this.loyaltyAllowance = !!res.results.LoyaltyAllowance
          this.loyaltyRewardsFull = res.results.Rewards || []
        }
      })
    },
    openDuplicateModal(category) {
      this.duplicatingCategory = category
      this.$nextTick(() => {
        this.duplicateModal = true
      })
    },
    onCategoryDuplicated(destination) {
      if (destination && destination.MenuTypeID === this.currentMenuType.MenuTypeID) {
        this.refreshCategories(this.currentMenuType)
      }
    },
    findDisplay(displayId) {
      const findDisplay = this.printStationList.find(item => item.PrinterID === displayId)
      return findDisplay ? findDisplay.PrinterName : 'None'
    },
    findKds(kdsId) {
      const findKds = this.kdsList.find(item => item.KDSID === kdsId)
      return findKds ? findKds.KDS : ''
    },
    showFood(category) {
      this.items.forEach(item => {
        if (item.CategoryID === category.CategoryID) {
          if (category.open) {
            item.open = false
          } else {
            // item.open = true
            this.getCategoryFoods(category)
          }
        }
      })
      // this.$emit('openCategory', category)
    },
    getCategoryFoods(category) {
      const params = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        EdibleType: this.edibleType,
        CategoryID: category.CategoryID
      }
      this.loadingFood = true
      return this.$api.foodDrink
        .list(params)
        .then(res => {
          const findCurrentCategory = this.items.find(item => item.CategoryID === category.CategoryID)
          if (findCurrentCategory) {
            findCurrentCategory.foods = res.data.FoodDrinks
            findCurrentCategory.IsAvailable = this.getCategoryStatus(findCurrentCategory)
            category.open = true
          }
        })
        .catch(err => {
          this.$showError('error on load foods')
        })
        .finally(() => {
          this.loadingFood = false
          this.resetFilters()
        })
    },
    changeAvailable(category) {
      const model = {
        // UserID: localStorage.getItem('userID'),
        RestaurantID: this.$store.state.selectedRestaurantId,
        EdibleType: this.edibleType,
        Available: this.getActiveFood(category) ? 0 : 1
      }
      return this.$api.category
        .updateAvailable(model, category.CategoryID, true)
        .then(() => {
          this.getCategoryFoods(category)
        })
        .catch(err => {})
    },
    getCategoryStatus(category) {
      const findNew = category.foods.find(item => item.IsAvailable)
      return findNew ? true : false
    },
    getActiveFood(category) {
      const findActiveItem = category.foods.find(item => item.IsAvailable)
      return !!findActiveItem
    },
    foodBoxColor(food) {
      if (!food.IsAvailable) {
        return 'deactive-food'
      } else {
        if (!this.currentMenuType.IsVisible) {
          return 'hidden-food'
        } else {
          return 'bg-white'
        }
      }
    },
    compliesWithFilters(food) {
      let result = true
      if (this.chefPickFilter && !food.ChefPick) {
        result = false
      }
      if (this.newFilter && !food.IsNew) {
        result = false
      }
      if (this.veggieFilter && (!food.Vegeterian && !food.Vegan && !food.VegeterianRequest && !food.VeganRequest)) {
        result = false
      }
    
      if (this.glutenFilter && (!food.GlutenFree && !food.GlutenFreeRequest)) {
        result = false
      }
      if (this.noPhotoFilter && food.Photo1 !== '') {
        result = false
      }
    return result
    },
    hasFoodWithProperty(categories, propName, valueToTest = true, extraCondition = null) {
      return categories.some(cat =>
        Array.isArray(cat.foods) && cat.foods.some(food => food[propName] === valueToTest && (extraCondition ? extraCondition(food) : true))
      );
    },
    resetFilters(){
    this.chefPickFilter = false
    this.newFilter = false
    this.veggieFilter = false
    this.glutenFilter = false
    this.noPhotoFilter = false
    this.DisabledchefPickFilter = !this.hasFoodWithProperty(this.items, 'ChefPick', true);
    this.DisablednewFilter = !this.hasFoodWithProperty(this.items, 'IsNew', true);
    this.DisabledveggieFilter = !this.hasFoodWithProperty(this.items, 'IsVeggie', true) 
    && !this.hasFoodWithProperty(this.items, 'VegeterianRequest', true) 
    && !this.hasFoodWithProperty(this.items, 'VeganRequest', true)
    && !this.hasFoodWithProperty(this.items, 'Vegeterian', true)
    && !this.hasFoodWithProperty(this.items, 'Vegan', true);
    this.DisabledglutenFilter = !this.hasFoodWithProperty(this.items, 'IsGlutenFree', true)
    && !this.hasFoodWithProperty(this.items, 'GlutenFreeRequest', true)
    && !this.hasFoodWithProperty(this.items, 'GlutenFree', true);
    this.DisablednoPhotoFilter = !this.hasFoodWithProperty(this.items, 'Photo1', '', food => food.Photo1 === '');

    }
  }
}
</script>

<style scoped>
.sticky-footer {
  position: sticky;
  top: 55px;
  z-index: 950;
}
.no-active-food {
  display: none !important;
}
</style>
